import WebLayout from './TextBadgeLayout.web'
import MobileLayout from './TextBadgeLayout.mobile'
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
